import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      d: "m13.9 2.7 1.9 3.8c.3.5 1 1 1.5 1.1l3.5.6c2.2.4 2.7 2 1.1 3.6l-2.7 2.7c-.5.5-.7 1.3-.6 2l.8 3.4c.6 2.7-.8 3.7-3.1 2.3L13 20.3c-.6-.3-1.6-.3-2.2 0l-3.3 1.9c-2.3 1.4-3.8.3-3.1-2.3l.8-3.4c.1-.6-.1-1.5-.6-2L2 11.9C.4 10.3.9 8.7 3.1 8.3l3.5-.6c.6-.1 1.3-.6 1.5-1.1L10 2.8c1.1-2.1 2.9-2.1 3.9-.1z"
    }, null, -1 /* CACHED */)
  ]))]))
}
export default { render: render }